import React from 'react';
import './Footer.css'

function Footer() {
    return (
        <div className='footer'>
                <div className="footer-bottom">
                    &copy; Birmind
                </div>
        </div>
    );
}
export default Footer;
